/**
 * nombre con que se almacena localmente las entidades obtenidas
 */
export const ENTITIES_STORAGE_NAME = 'entities';

/**
 * nombre con que se almacena localmente los datos de la instancia hub
 */
export const HUB_INSTANCE_STORAGE_NAME = 'hub_instance';

/**
 * nombre con que se almacena localmente el token de login
 */
export const USER_TOKEN_STORAGE_NAME = 'token';

/**
 * nombre con que se almacena localmente el dato para saber si el login funcionario fue exitoso.
 */
export const FUNCTIONARY_LOGIN_STORAGE_NAME = 'isLoginFunctionary';

/**
 * nombre con que se almacena localmente los datos de la empresa hub
 */
export const HUB_COMPANY_STORAGE_NAME = 'hub_company';

/**
 * nombre con que se almacena localmente los productos del servicio
 */
export const ERP_PRODUCTS_STORAGE_NAME = 'erp_products';

/**
 * nombre con que se almacena localmente los productos finales
 */
export const PRICELIST_PRODUCTS_STORAGE_NAME = 'products';

/**
 * nombre con que se almacena localmente llas listas de precios
 */
export const PRICELIST_STORAGE_NAME = 'price_lists';

/**
 * nombre con que se almacena localmente el nombre de usuario actual loggeado.
 */
export const CURRENT_USER = 'current_user';

/**
 * nombre con que se almacena localmente el nombre de vendedor actual loggeado.
 */
export const FUNCTIONARY_USER = 'functionary_user';

/**
 * nombre con que se almacena localmente los documentos.
 */
export const DOCUMENTS_STORAGE_NAME = 'documents';
